import { AdditionalLoads, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { ManualLoadSchema } from './ManualLoadSchema';
import { MovingLoadSchema } from './MovingLoadSchema';
import { ParapetLoadSchema } from './ParapetLoadSchema';

export const AdditionalLoadsSchema = new ModelSchema<AdditionalLoads>('additionalLoads', {
  category: ModelCategory.ComponentDesignData,
  displayName: 'Additional Loads',

  children: {
    manualLoads: ManualLoadSchema,
    movingLoads: MovingLoadSchema,
    parapetLoads: ParapetLoadSchema,
  },

  properties: {},
});
